module.exports = __webpack_public_path__ + "img/pvc_360g_farbauswahl_blau_elfenbein.01bad000.jpg";